import { fetchWithOptionalAuth } from '../api/fetchWithAuth';

export const validateViToken = async (data, checksum, encryptedTimestamp) => {
  try {
    const response = await fetchWithOptionalAuth(`/vi/auth/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data, checksum, encryptedTimestamp }),
    });
    
    return response.json();
  } catch (error) {
    console.error('Vi token validation failed:', error);
    return {
      success: false,
      error: 'NETWORK_ERROR',
    };
  }
};

export const clearViAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userId');
  localStorage.removeItem('isViUser');
  localStorage.removeItem('requestTimestamp');
};
